import Vue from 'vue';

const state = {
    data: [],
};

const getters = {
    getEntries(state) {
        return state.data;
    },
    getSelectableEntries(state) {
        const listItem = [];

        if (state.data.length <= 0) {
            return [];
        }

        Array.from(state.data).forEach((item) => {
            listItem.push({value: item.id, label: item.title});
        });
        return listItem;
    }
};

const mutations = {
    SET_DATA(state, lots) {
        state.data = lots;
    },
};

const actions = {

    setEntry: function({dispatch, commit}) {
        commit('SET_DATA', {
            id: '',
            title: '',
            images: [],
            video: '',
        });
    },

    loadEntries: function ({dispatch, commit}, postID = 0) {

        const ID = postID || '';
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/lots/" + ID)
                .then(({data}) => {

                    let lotRows = [];

                    if (data instanceof Array) {

                        data.forEach((lot) => {

                            lotRows.push({
                                id: lot.id,
                                title: lot.title.rendered,
                                images: lot.acf.images.length,
                                video: lot.acf.video,
                            })

                        });

                    } else {

                        lotRows = {
                            id: data.id,
                            title: data.title.rendered,
                            images: data.acf.images || [],
                            video: data.acf.video,
                        }

                    }

                    commit('SET_DATA', lotRows);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    updateEntry({dispatch, commit, state}) {

        const lotData = state.data;
        const ID = lotData.id;

        const images = [];

        lotData.images.forEach((item) => {
            images.push(item.ID);
        });

        const params = {
            title: lotData.title,
            fields: {
                video: lotData.video,
                images: images
            },
            status: 'publish'
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/wp/v2/lots/" + ID, params)
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

};

export const lots = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};